import { Link } from "react-router-dom";
import Navbar from "../../Components/NavBar/index";
import Footer from "../../Components/Footer/index";
import SEO from "../../Components/SEO/index";

// Shown for any URL that does not match a route. The server also returns HTTP 404
// for these URLs, so search engines do not index them as duplicate pages.
const NotFound = () => {
    return (
        <>
            <SEO pageName="notfound" indexPage={false} />
            <Navbar />
            <section className="bg-white min-h-[60vh] flex items-center">
                <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16 text-center">
                    <p className="text-orange-500 font-semibold text-sm tracking-widest uppercase">404</p>
                    <h1 className="mt-3 text-3xl md:text-4xl font-bold text-gray-900">Page not found</h1>
                    <p className="mt-4 text-gray-600">
                        The page you are looking for does not exist or has moved.
                    </p>
                    <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
                        <Link to="/" className="px-6 py-3 rounded-full bg-orange-500 text-white font-medium hover:bg-orange-600 transition-colors">
                            Go to Home
                        </Link>
                        <Link to="/blog" className="px-6 py-3 rounded-full border border-gray-300 text-gray-800 font-medium hover:border-orange-500 hover:text-orange-500 transition-colors">
                            Read the Blog
                        </Link>
                        <Link to="/contact" className="px-6 py-3 rounded-full border border-gray-300 text-gray-800 font-medium hover:border-orange-500 hover:text-orange-500 transition-colors">
                            Contact Us
                        </Link>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default NotFound;
